export function calculateGuestUsed({
  sharedTotal = 0,
  sharedTypeMax = null,
  soloTotals = [],
}) {
  const sharedExcess =
    sharedTypeMax != null ? Math.max(0, sharedTotal - sharedTypeMax) : 0;
  const soloExcess = soloTotals.reduce(
    (sum, { value, typeMax }) => sum + Math.max(0, value - typeMax),
    0,
  );
  return sharedExcess + soloExcess;
}

export function canIncrementWithGuestPool({
  groupTotal,
  typeMax,
  guestRemaining,
  value,
  absoluteMax = null,
  sectionTotal = null,
  sectionLimit = null,
}) {
  return (
    (groupTotal < typeMax || guestRemaining > 0) &&
    (absoluteMax == null || value < absoluteMax) &&
    (sectionLimit == null || sectionTotal < sectionLimit)
  );
}
